'use client';
import HomeViewPaper from '@/src/components/HomeViewPaper';
import LoginFlow from '../../../components/LoginFlow';

export default function HomeLoginPage() {
  return (
    <HomeViewPaper>
      <LoginFlow />
    </HomeViewPaper>
  );
}
